import { render, staticRenderFns } from "./DefaultHeader.vue?vue&type=template&id=0a384748"
import script from "./DefaultHeader.vue?vue&type=script&lang=js"
export * from "./DefaultHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports